import {
    GET_JOB_PACK,
    GET_NEW_JOB_PACK_UID,
    GET_USERS,
    GET_SSWP_CONFIGS,
    GET_REPORT_TYPES
} from "./types";
import { combineReducers } from "redux";
import { JobPackProfileRelatedReportsWidget } from "../../../widgets";
const INITIAL_STATE = {
    requesting: false,
    jobPack: false,
    newJobPackID: false,
    users: false,
    reportTypes: false,
    sswpConfigs: false
};

const mainReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_JOB_PACK.REQUEST: {
            return { ...state, requesting: false, jobPack: false };
        }
        case GET_JOB_PACK.FAIL: {
            return { ...state, requesting: false, jobPack: false };
        }
        case GET_JOB_PACK.SUCCESS: {
            return { ...state, requesting: false, jobPack: action.payload };
        }
        case GET_NEW_JOB_PACK_UID.REQUEST: {
            return { ...state, requesting: true, newJobPackID: false };
        }
        case GET_NEW_JOB_PACK_UID.FAIL: {
            return { ...state, requesting: false, newJobPackID: false };
        }
        case GET_NEW_JOB_PACK_UID.SUCCESS: {
            return {
                ...state,
                requesting: false,
                newJobPackID: action.payload
            };
        }
        case GET_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case GET_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case GET_REPORT_TYPES.REQUEST: {
            return { ...state, requesting: true, reportTypes: false };
        }
        case GET_REPORT_TYPES.FAIL: {
            return { ...state, requesting: false, reportTypes: false };
        }
        case GET_REPORT_TYPES.SUCCESS: {
            return { ...state, requesting: false, reportTypes: action.payload };
        }
        case GET_SSWP_CONFIGS.REQUEST: {
            return { ...state, requesting: true, sswpConfigs: false };
        }
        case GET_SSWP_CONFIGS.FAIL: {
            return { ...state, requesting: false, sswpConfigs: false };
        }
        case GET_SSWP_CONFIGS.SUCCESS: {
            return { ...state, requesting: false, sswpConfigs: action.payload };
        }
        default: {
            return { ...state };
        }
    }
};

export default combineReducers({
    mainReducer,
    [JobPackProfileRelatedReportsWidget.reducer_key]:
        JobPackProfileRelatedReportsWidget.reducer
});
